import React, {
    createContext,
    useContext,
    useRef,
    useCallback,
} from 'react';

interface TableSyncContextType {
    registerTable: (id: string, ref: React.RefObject<HTMLDivElement>) => void;
    unregisterTable: (id: string) => void;
    getTableRef: (id: string) => React.RefObject<HTMLDivElement> | undefined;
}

const TableSyncContext = createContext<TableSyncContextType | null>(null);

export const TableSyncProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const tableRefs = useRef<Map<string, React.RefObject<HTMLDivElement>>>(new Map());

    const registerTable = useCallback((id: string, ref: React.RefObject<HTMLDivElement>) => {
        tableRefs.current.set(id, ref);
    }, []);

    const unregisterTable = useCallback((id: string) => {
        tableRefs.current.delete(id);
    }, []);

    const getTableRef = useCallback((id: string) => {
        const ref = tableRefs.current.get(id);
        return ref;
    }, []);

    return (
        <TableSyncContext.Provider value={{ registerTable, unregisterTable, getTableRef }}>
            {children}
        </TableSyncContext.Provider>
    );
};

export const useTableSync = () => {
    const context = useContext(TableSyncContext);
    if (!context) {
        throw new Error('useTableSync must be used within a TableSyncProvider');
    }
    return context;
};
